import b from 'b_';
import { Button, SimpleCallback, SimpleText } from 'platform-components';
import React from 'react';

import './certificate-card__button_change-data.scss';

interface Props {
    onChangeDataButtonClick: SimpleCallback;
}

export const CertificateCardButtonChangeData = (props: Props) => {
    const { onChangeDataButtonClick } = props;

    return (
        <Button
            className={b('certificate-card__button', { ['change-data']: true })}
            onClick={onChangeDataButtonClick}
            view={Button.VIEW.PSEUDO}
        >
            <SimpleText id="teacherLK.card.buttonText.changePersonalData" />
        </Button>
    );
};
